import { HorseSilhouette } from "@/components/game/HorseSilhouette";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Renders a horse's fixed commissioned artwork when assigned; otherwise falls back to the
// procedural colored silhouette. `src` is a stored path like "/api/files/..." or an absolute URL.
export const HorseArt = ({ src, color = "#6b3f22", size = 96, className = "" }) => {
  if (src) {
    const url = src.startsWith("http") ? src : `${BACKEND}${src}`;
    return (
      <img data-testid="horse-art-img" src={url} alt="mustang"
        style={{ width: size, height: size, objectFit: "contain" }}
        className={className} />
    );
  }
  return <HorseSilhouette color={color} size={size} className={className} />;
};
